import {
  Component,
  Inject
} from '@angular/core';

import { CommonModule }
from '@angular/common';

import {
  MAT_DIALOG_DATA,
  MatDialogModule
} from '@angular/material/dialog';

@Component({
  selector: 'app-tax-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule
  ],
  templateUrl: './tax-dialog.component.html'
})
export class TaxDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  get totalTax(): number {

    return (
      this.data?.taxLines || []
    ).reduce(

      (total: number, row: any) =>

        total +
        Number(
          row.taxAmount ??
          row.tax_amount ??
          0
        ),

      0
    );
  }
}